import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { WorkoutResult } from 'types';
import { client } from 'utils/api-client';

import { LogWorkoutResultInput } from './useLogWorkoutResult';

// Coach-on-behalf payload. Hits POST /workout-results/ (the `create` action),
// gated server-side by ["owner", "staff"]. The athlete-self path lives in
// useLogWorkoutResult and posts to /workout-results/log/ instead.
export type CreateWorkoutResultInput = LogWorkoutResultInput & { athlete: string };

function useLogWorkoutResultAsStaff(
  workoutId: string | undefined,
): UseMutationResult<AxiosResponse<WorkoutResult>, AxiosError, CreateWorkoutResultInput> {
  const queryClient = useQueryClient();
  return useMutation(
    (input: CreateWorkoutResultInput) => client.post<WorkoutResult>('workout-results/', input),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['workout-athlete-results', workoutId]);
        queryClient.invalidateQueries(['workout-leaderboard', workoutId]);
      },
    },
  );
}

export default useLogWorkoutResultAsStaff;
